import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { MapCompanyRole } from '@/creditflowresearch/application/League/constants';
import { useProductRegionFilters } from '@/creditflowresearch/application/League/Scorecard/hooks/useProductRegionFilters';
import { useScorecardFilters } from '@/creditflowresearch/application/League/Scorecard/hooks/useScorecardFilters';
import { IScorecardProps } from '@/creditflowresearch/application/League/Scorecard/types';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import { IScorecardCompanyData } from '@/creditflowresearch/application/League/interfaces';
import { IStandingsPayload, IStandingsResponse } from '@/creditflowresearch/domain/vo/League/IStandings';

export const useScorecardFilterOrchestrator = (
  props: IScorecardProps,
  productsCollection: IProduct[],
  regionsCollection: IRegion[],
  getStandings?: (payload: IStandingsPayload) => Promise<IStandingsResponse>,
  companyData?: IScorecardCompanyData,
) => {
  const router = useRouter();
  const enhancedOnFiltersChange = useCallback((productIds: string[], regionIds: string[]) => {
    if (getStandings && companyData?.id) {
      const valueLeagueType = Array.isArray(router.query.leagueType)
        ? router.query.leagueType[0]
        : router.query.leagueType;
      const companyRole = MapCompanyRole[valueLeagueType];

      const standingsFiltersPayload = {
        filters: {
          includedProductIds: productIds,
          includedRegionIds: regionIds,
          includedCompanyId: companyData.id,
          includedCompanyRole: companyRole,
        },
      };

      getStandings(standingsFiltersPayload);
    }
  }, [router.query.leagueType, getStandings, companyData?.id]);

  const { initProductRegionFilters, activeProductIds, activeRegionIds } = useProductRegionFilters({
    productsCollection,
    regionsCollection,
    onFiltersChange: enhancedOnFiltersChange,
  });

  const { scorecardFilters, updateFilters } = useScorecardFilters(
    props,
    activeProductIds,
    activeRegionIds,
  );

  return {
    scorecardFilters,
    updateFilters,
    enhancedOnFiltersChange,
    initProductRegionFilters,
    activeProductIds,
    activeRegionIds,
  };
};
